import React from 'react';
import './CheckoutProduct.css';
import { useStateValue } from './StateProvider';

function CheckoutProduct({id,image,title,price,rating, size}) {
    const [{basket}, dispatch] = useStateValue();
    const removeFromBasket = () =>{
        dispatch({
            type:"REMOVE_FROM_BASKET",
            id:id,
        })
    }
  return (
    <div className='checkoutProduct'>
        <img className='checkoutProduct__image' src = {image}/>
        <div className='checkoutProduct__info'>
            <p className='checkoutProduct__title'>{title}</p>
            {size && (
          <p className="checkoutProduct__size">Size: {size}</p>
        )}
            <p className='checkoutProduct__price'>
                <small>₹</small>
                <strong>{price}</strong><br/>
            <button onClick={removeFromBasket}>Remove from Bag</button>
            </p>
        </div>
    </div>
  )
}

export default CheckoutProduct